var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"code",attrs:{"name":"code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }